module.exports = __webpack_public_path__ + "07e2cd6fccababa8d821af079570154d.png";